import { areSameInsurance } from "../line-item-matchers/insurance/utils/line-item-matchers/insurance/are-same-insurance.js";
import { areSameContactLenses } from "../line-item-matchers/contact-lenses/utils/line-item-matchers/contact-lenses/are-same-contact-lenses.js";
import { areSamePrescriptionGlassesLineItem } from "../line-item-matchers/prescription-glasses/utils/line-item-matchers/prescription-glasses/prescription-glasses-bundle.js";
import { areSameNonPrescriptionBundleLineItem } from "../line-item-matchers/non-rx-bundle/utils/line-item-matchers/non-rx-bundle/are-same-non-prescription-bundle.js";
import { areSameRegularProduct } from "../line-item-matchers/regular/utils/line-item-matchers/regular/are-same-regular-product.js";
const sameProduct = (serverLineItem, draft) => {
  switch (draft.type) {
    case "regular":
      return areSameRegularProduct(serverLineItem, draft);
    case "non-prescription-bundle":
      return areSameNonPrescriptionBundleLineItem(serverLineItem, draft);
    case "prescription-glasses":
      return areSamePrescriptionGlassesLineItem(serverLineItem, draft);
    case "contact-lenses":
      return areSameContactLenses(serverLineItem, draft);
    case "insurance":
      return areSameInsurance(serverLineItem, draft);
  }
};
const getAddedLineItems = (lineItemsInCart, newLineItems) => {
  return lineItemsInCart.reduce((m, cartLineItem) => {
    const matchingCartLineItem = newLineItems.find(sameProduct.bind(null, cartLineItem));
    if (!matchingCartLineItem) {
      return m;
    }
    const quantity = matchingCartLineItem?.quantity ?? 1;
    if (cartLineItem.quantity === quantity) {
      return [...m, cartLineItem];
    }
    return [
      ...m,
      {
        ...cartLineItem,
        quantity,
        price: getTotalPricePerAddedQuantity(cartLineItem.price, quantity)
      }
    ];
  }, []);
};
const getTotalPricePerAddedQuantity = (price, quantity) => ({
  ...price,
  total: {
    ...price.total,
    gross: price.unit.gross * quantity,
    net: price.unit.net * quantity,
    subtotal: price.unit.subtotal * quantity,
    discount: {
      ...price.total.discount,
      amount: price.unit.discount.amount * quantity
    },
    tax: {
      ...price.total.tax,
      amount: price.unit.tax.amount * quantity,
      portions: price.unit.tax.portions.map((portion, index) => {
        const amount = price.unit.tax.portions[index]?.amount ?? 0;
        return {
          ...portion,
          amount: amount * quantity
        };
      })
    }
  }
});
export {
  getAddedLineItems
};
//# sourceMappingURL=get-added-line-items.js.map
